import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { QuienesSomos } from './components/QuienesSomos';
import { ComoPensamos } from './components/ComoPensamos';
import { Servicios } from './components/Servicios';
import { Modalidades } from './components/Modalidades';
import { ComoTrabajamos } from './components/ComoTrabajamos';
import { CTAFinal } from './components/CTAFinal';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-body text-gray-900 antialiased selection:bg-petrol-dark selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <QuienesSomos data-id="element-4" />
        <ComoPensamos data-id="element-5" />
        <Servicios data-id="element-6" />
        <Modalidades data-id="element-7" />
        <ComoTrabajamos data-id="element-8" />
        <CTAFinal data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}